/* eslint-disable max-lines */
export const enum PageId {
  // love
  DOG_SEX_LOVE = 'sex_love',
  DOG_AGE_LOVE = 'dog_age_love',
  URGE_LOVE = 'urge_love',
  FEELINGS_LOVE = 'feelings_love',
  DOG_FOLLOW_LOVE = 'dog_follow_love',
  TALKING_LOVE = 'talking_love',
  LICKING_LOVE = 'licking_love',
  URGE_2_LOVE = 'urge_2_love',
  BEHAVIOR_LOVE = 'behavior_love',
  FEEL_GUILTY_LOVE = 'feel_guilty_love',
  URGE_3_LOVE = 'urge_3_love',
  DOG_REACT_LOVE = 'dog_react_love',
  SATISFIED_LOVE = 'satisfied_love',
  BEHAVIOR_ISSUES_LOVE = 'behavioral_issues_love',
  YOUR_REACTION_LOVE = 'your_reaction_love',
  URGE_4_LOVE = 'urge_4_love',
  COMMANDS_LOVE = 'commands_love',
  DOG_BREED_LOVE = 'dog_breed_love',
  DOG_NAME_LOVE = 'dog_name_love',
  DOG_PROFILE_LOVE = 'dog_profile_love',
  MOTIVATION_LOVE = 'motivation_love',
  FEEL_DOG_LOVE = 'feel_dog_love',
  FREQUENCY_LOVE = 'frequency_love',
  PREPARE_FLOW_LOVE = 'prepare_flow_love',
  EMAIL_LOVE = 'email_love',
  PERSONALIZED_PLAN_LOVE = 'personalized_plan_love',
  LAST_CHANCE_OFFER_LOVE = 'last_chance_offer_love',
  SUBSCRIPTIONS_LOVE = 'subscriptions_love',
  CANCEL_OFFER_LOVE = 'cancel_offer_love',
  LAST_CHANCE_OFFER_2_LOVE = 'last_chance_offer_2_love',
  NEWSLETTER_URGE_LOVE = 'newsletter_urge_love',
  CHAT_UPSELL_LOVE = 'chat_upsell_love',
  UPSELL_LOVE = 'upsell_love',
  UPSELL_FEEDING_GUIDE_LOVE = 'upsell_feeding_guide_love',
  UPSELL_EMOTIONAL_SUPPORT_LOVE = 'upsell_emotional_support_love',
  DOWNLOAD_LOVE = 'download_love',
  URGE_1_LOVE = 'urge_1_love',

  // woofz_love_bl
  DOG_SEX_LOVE_BL = 'sex_love_bl',
  DOG_AGE_LOVE_BL = 'dog_age_love_bl',
  URGE_LOVE_BL = 'urge_love_bl',
  FEELINGS_LOVE_BL = 'feelings_love_bl',
  DOG_FOLLOW_LOVE_BL = 'dog_follow_love_bl',
  TALKING_LOVE_BL = 'talking_love_bl',
  LICKING_LOVE_BL = 'licking_love_bl',
  URGE_2_LOVE_BL = 'urge_2_love_bl',
  BEHAVIOR_LOVE_BL = 'behavior_love_bl',
  FEEL_GUILTY_LOVE_BL = 'feel_guilty_love_bl',
  URGE_3_LOVE_BL = 'urge_3_love_bl',
  DOG_REACT_LOVE_BL = 'dog_react_love_bl',
  SATISFIED_LOVE_BL = 'satisfied_love_bl',
  BEHAVIOR_ISSUES_LOVE_BL = 'behavioral_issues_love_bl',
  YOUR_REACTION_LOVE_BL = 'your_reaction_love_bl',
  URGE_4_LOVE_BL = 'urge_4_love_bl',
  DOG_BREED_LOVE_BL = 'dog_breed_love_bl',
  COMMANDS_LOVE_BL = 'commands_love_bl',
  DOG_NAME_LOVE_BL = 'dog_name_love_bl',
  DOG_PROFILE_LOVE_BL = 'dog_profile_love_bl',
  MOTIVATION_LOVE_BL = 'motivation_love_bl',
  FEEL_DOG_LOVE_BL = 'feel_dog_love_bl',
  FREQUENCY_LOVE_BL = 'frequency_love_bl',
  PREPARE_FLOW_LOVE_BL = 'prepare_flow_love_bl',
  EMAIL_LOVE_BL = 'email_love_bl',
  PERSONALIZED_PLAN_LOVE_BL = 'personalized_plan_love_bl',
  LAST_CHANCE_OFFER_LOVE_BL = 'last_chance_offer_love_bl',
  SUBSCRIPTIONS_LOVE_BL = 'subscriptions_love_bl',
  CANCEL_OFFER_LOVE_BL = 'cancel_offer_love_bl',
  LAST_CHANCE_OFFER_2_LOVE_BL = 'last_chance_offer_2_love_bl',
  NEWSLETTER_URGE_LOVE_BL = 'newsletter_urge_love_bl',
  CHAT_UPSELL_LOVE_BL = 'chat_upsell_love_bl',
  UPSELL_LOVE_BL = 'upsell_love_bl',
  UPSELL_FEEDING_GUIDE_LOVE_BL = 'upsell_feeding_guide_love_bl',
  UPSELL_EMOTIONAL_SUPPORT_LOVE_BL = 'upsell_emotional_support_love_bl',
  DOWNLOAD_LOVE_BL = 'download_love_bl',
  URGE_1_LOVE_BL = 'urge_1_love_bl',
  LOVE_LOAD_SCREEN_BL = 'love_load_screen_bl',

  // pn
  SEX_PN = 'sex_pn',
  DOG_AGE_PN = 'dog_age_pn',
  BIGGEST_CHALLENGE_PN = 'biggest_challenge_pn',
  DOG_BREED_PN = 'dog_breed_pn',
  DOG_BREED_ID_PN = 'dog_breed_id_pn',
  URGE_PN = 'urge_pn',
  YELLING_MOMENTS_PN = 'yelling_moments_pn',
  FEELINGS_PN = 'feelings_pn',
  URGE_2_PN = 'urge_2_pn',
  CHALLENGES_PN = 'challenges_pn',
  REACTION_PN = 'reaction_pn',
  BARKING_PN = 'barking_pn',
  IMPROVE_PN = 'improve_pn',
  FOLLOW_COMMANDS_PN = 'follow_commands_pn',
  COMMANDS_61_PN = 'commands_61_pn',
  COMMANDS_62_PN = 'commands_62_pn',
  COMMANDS_63_PN = 'commands_63_pn',
  URGE_3_PN = 'urge_3_pn',
  URGE_4_PN = 'urge_4_pn',
  TOYS_PN = 'toys_pn',
  FREQUENCY_PN = 'frequency_pn',
  PREPARE_FLOW_PN = 'prepare_flow_pn',
  DOG_STATISTICS_PN = 'dog_statistics_pn',
  EMAIL_PN = 'email_pn',
  LAST_CHANCE_OFFER_PN = 'last_chance_offer_pn',
  SUBSCRIPTIONS_PN = 'subscriptions_pn',
  NEWSLETTER_URGE_PN = 'newsletter_urge_pn',
  CHAT_UPSELL_PN = 'chat_upsell_pn',
  UPSELL_PN = 'upsell_pn',
  DOWNLOAD_PN = 'download_pn',
  LOVE_LOAD_SCREEN = 'love_load_screen',

  // woofz_vgs
  SEX_VGS = 'sex_vgs',
  DOG_AGE_VGS = 'dog_age_vgs',
  DOG_BREED_VGS = 'dog_breed_vgs',
  URGE_VGS = 'urge_vgs',
  OTHER_DOGS_VGS = 'other_dogs_vgs',
  NOISES_VGS = 'noises_vgs',
  LEASH_PULLING_VGS = 'leash_pulling_vgs',
  BARKS_VGS = 'barks_vgs',
  OUT_OF_CONTROL_VGS = 'out_of_control_vgs',
  URGE_2_VGS = 'urge_2_vgs',
  BEHAVIOR_VGS = 'behavior_vgs',
  TRIGGERS_VGS = 'triggers_vgs',
  CALM_DOWN_VGS = 'calm_down_vgs',
  DOG_REACT_VGS = 'dog_react_vgs',
  STRESSFUL_WALKS_VGS = 'stressful_walks_vgs',
  URGE_3_VGS = 'urge_3_vgs',
  DOG_ACT_VGS = 'dog_act_vgs',
  DOG_OFF_AT_HOME_VGS = 'dog_off_at_home_vgs',
  AGGRESSIVE_VGS = 'aggressive_vgs',
  DOG_IGNORED_VGS = 'dog_ignored_vgs',
  LOADER_SCREEN_VGS = 'loader_screen_vgs',
  DOG_STATISTICS_VGS = 'dog_statistics_vgs',
  TIME_VGS = 'time_vgs',
  PREPARE_FLOW_VGS = 'prepare_flow_vgs',
  EMAIL_VGS = 'email_vgs',
  NEWSLETTER_VGS = 'newsletter_vgs',
  PERSONALIZED_PLAN_VGS = 'personalized_plan_vgs',
  LAST_CHANCE_OFFER_VGS = 'last_chance_offer_vgs',
  SUBSCRIPTIONS_VGS = 'subscriptions_vgs',
  UPSELL_VGS = 'upsell_vgs',
  CHAT_UPSELL_VGS = 'chat_upsell_vgs',
  DOWNLOAD_VGS = 'download_vgs',
  URGE_4_VGS = 'urge_4_vgs',
  URGE_5_VGS = 'urge_5_vgs',
  URGE_TOUCH = 'urge_touch',

  // woofz_ws2
  SEX_WS2 = 'sex_ws2',
  URGE_WS2 = 'urge_ws2',
  AGE_WS2 = 'age_ws2',
  BREED_WS2 = 'breed_ws2',
  URGE_WS2_2 = 'urge_ws2_2',
  WORRIES_WS2 = 'worries_ws2',
  URGE_WS2_3 = 'urge_ws2_3',
  LICK_PAWS_WS2 = 'lick_paws_ws2',
  DRAG_BOTTOM_WS2 = 'drag_bottom_ws2',
  CHECK_EARS_WS2 = 'check_ears_ws2',
  WASH_TEETH_WS2 = 'wash_teeth_ws2',
  CLEAN_EYES_WS2 = 'clean_eyes_ws2',
  BREATH_WS2 = 'breath_ws2',
  WEIGHT_WS2 = 'weight_ws2',
  FEED_WS2 = 'feed_ws2',
  FOOD_PORTIONS_WS2 = 'food_portions_ws2',
  URGE_WS2_4 = 'urge_ws2_4',
  WATER_WS2 = 'water_ws2',
  CLEAN_BOWLS_WS2 = 'clean_bowls_ws2',
  COAT_WS2 = 'coat_ws2',
  WALK_WS2 = 'walk_ws2',
  URGE_WS2_5 = 'urge_ws2_5',
  VET_WS2 = 'vet_ws2',
  PROTECT_WS2 = 'protect_ws2',
  CHRONIC_WS2 = 'chronic_ws2',
  BEHAVIOR_CHANGES_WS2 = 'behaviour_changes_ws2',
  URGE_WS2_6 = 'urge_ws2_6',
  ITCH_WS2 = 'itch_ws2',
  ALONE_WS2 = 'alone_ws2',
  URGE_WS2_7 = 'urge_ws2_7',
  SLEEP_WS2 = 'sleep_ws2',
  SLEEPING_ENV_WS2 = 'sleeping_env_ws2',
  URGE_WS2_8 = 'urge_ws2_8',
  DOG_NAME_WS2 = 'dog_name_ws2',
  SPEND_TIME_WS2 = 'spend_time_ws2',
  PREPARE_FLOW_WS2 = 'prepare_flow_ws2',
  EMAIL_WS2 = 'email_ws2',
  NEWSLETTER_URGE_WS2 = 'newsletter_urge_ws2',
  URGE_WS2_9 = 'urge_ws2_9',
  GIFT_WS2 = 'gift_ws2',
  WELCOME_WS2 = 'welcome_ws2',
  SUBSCRIPTIONS_WS2 = 'subscriptions_ws2',
  // PAYMENT_WS2 = 'payment_ws2',
  CHAT_UPSELL_WS2 = 'chat_upsell_ws2',
  UPSELL_WS2 = 'upsell_ws2',
  DOWNLOAD_WS2 = 'download_ws2',
  // LAST_CHANCE_OFFER_WS2 = 'last_chance_offer_ws2',
  CANCEL_OFFER_WS2 = 'cancel_offer_ws2',

  // woofz_22_v4l
  SEX_V4L = 'sex_v4l',
  DOG_AGE_V4L = 'dog_age_v4l',
  DOG_BREED_V4L = 'dog_breed_v4l',
  URGE_V4L = 'urge_v4l',
  COMMANDS_61_V4L = 'commands_61_v4l',
  COMMANDS_62_V4L = 'commands_62_v4l',
  COMMANDS_63_V4L = 'commands_63_v4l',
  URGE_2_V4L = 'urge_2_v4l',
  POTTY_V4L = 'potty_v4l',
  BEHAVIOR_V4L = 'behavior_v4l',
  TRAINING_V4L = 'training_v4l',
  PREPARE_FLOW_V4L = 'prepare_flow_v4l',
  DOG_STATISTICS_V4L = 'dog_statistics_v4l',
  EMAIL_V4L = 'email_v4l',
  NEWSLETTER_URGE_V4L = 'newsletter_urge_v4l',
  CHAT_UPSELL_V4L = 'chat_upsell_v4l',
  UPSELL_V4L = 'upsell_v4l',
  UPSELL_PITPAT_V4L = 'upsell_pitpat_v4l',
  DOWNLOAD_V4L = 'download_v4l',
  SUBSCRIPTIONS_V4L_2 = 'subscriptions_v4l_2',
  LAST_CHANCE_OFFER_V4L = 'last_chance_offer_v4l',

  // woofz_esa
  INTRO_ESA = 'intro_esa',
  MOTIVATION_ESA = 'motivation_esa',
  YOUR_AGE_ESA = 'your_age_esa',
  ESA_LETTER = 'esa_letter',
  ACCOMPANY_ESA = 'accompany_esa',
  HAPPINESS_ESA = 'happiness_esa',
  SADNESS_ESA = 'sadness_esa',
  TRY_ESA = 'try_esa',
  FULL_SUPPORT_ESA = 'full_support_esa',
  EXPERT_ESA = 'expert_esa',
  PERSONALIZED_ESA = 'personalized_esa',
  MENTAL_HEALTH_ESA = 'mental_health_esa',
  SADNESS_LAST_WEEKS_ESA = 'sadness_last_weeks_esa',
  ANGER_LAST_WEEKS_ESA = 'anger_last_weeks_esa',
  WORRY_LAST_WEEKS_ESA = 'worry_last_weeks_esa',
  AFRAID_LAST_WEEKS_ESA = 'afraid_last_weeks_esa',
  SLEEP_LAST_WEEKS_ESA = 'sleep_last_weeks_esa',
  NERVOUS_LAST_WEEKS_ESA = 'nervous_last_weeks_esa',
  MEMORY_LAST_WEEKS_ESA = 'memory_last_weeks_esa',
  FOCUS_ESA = 'focus_esa',
  EMOTIONAL_SCORE_ESA = 'emotional_score_esa',
  DOG_NOTICE_UPSET_ESA = 'dog_notice_upset_esa',
  DOG_NEXT_TO_YOU_ESA = 'dog_next_to_you_esa',
  DOG_SUPPORT_CUES_ESA = 'dog_support_cues_esa',
  STATS_ESA = 'stats_esa',
  DOG_BREED_ESA = 'dog_breed_esa',
  DOG_AGE_ESA = 'dog_age_esa',
  DOG_SIZE_ESA = 'dog_size_esa',
  URGE_ESA = 'urge_esa',
  PREPARE_FLOW_ESA = 'prepare_flow_esa',
  PLAN_ESA = 'plan_esa',
  EMAIL_ESA = 'email_esa',
  SUBSCRIPTIONS_ESA = 'subscriptions_esa',
  CANCEL_OFFER_ESA = 'cancel_offer_esa',
  CHAT_UPSELL_ESA = 'chat_upsell_esa',
  UPSELL_ESA = 'upsell_esa',
  DOWNLOAD_ESA = 'download_esa',

  // woofz_rfnd3_nd
  SEX_RFND3_ND = 'sex_rfnd3_nd',
  DOG_AGE_RFND3_ND = 'dog_age_rfnd3_nd',
  DOG_BREED_RFND3_ND = 'dog_breed_rfnd3_nd',
  URGE_RFND3_ND = 'urge_rfnd3_nd',
  COMMANDS_61_RFND3_ND = 'commands_61_rfnd3_nd',
  COMMANDS_62_RFND3_ND = 'commands_62_rfnd3_nd',
  COMMANDS_63_RFND3_ND = 'commands_63_rfnd3_nd',
  URGE_RFND3_2_ND = 'urge_rfnd3_2_nd',
  POTTY_RFND3_ND = 'potty_rfnd3_nd',
  BEHAVIOR_RFND3_ND = 'behavior_rfnd3_nd',
  TRAINING_RFND3_ND = 'training_rfnd3_nd',
  PREPARE_FLOW_RFND3_ND = 'prepare_flow_rfnd3_nd',
  DOG_STATISTICS_RFND3_ND = 'dog_statistics_rfnd3_nd',
  EMAIL_RFND3_ND = 'email_rfnd3_nd',
  NEWSLETTER_URGE_RFND3_ND = 'newsletter_urge_rfnd3_nd',
  LAST_CHANCE_OFFER_RFND3_ND = 'last_chance_offer_rfnd3_nd',
  SUBSCRIPTIONS_RFND3_ND = 'subscriptions_rfnd3_nd',
  CANCEL_OFFER_RFND3_ND = 'cancel_offer_rfnd3_nd',
  CHAT_UPSELL_RFND3_ND = 'chat_upsell_rfnd3_nd',
  UPSELL_RFND3_ND = 'upsell_1_rfnd3_nd',
  DOWNLOAD_RFND3_ND = 'download_rfnd3_nd',

  // woofz22_v3
  SEX_22V3 = 'sex_22v3',
  DOG_AGE_22V3 = 'dog_age_22v3',
  DOG_BREED_22V3 = 'dog_breed_22v3',
  DOG_BREED_ID_22V3 = 'dog_breed_id_22v3',
  PREPARE_FLOW_22V3 = 'prepare_flow_22v3',
  URGE_22V3 = 'urge_22v3',
  COMMANDS_61_22V3 = 'commands_61_22v3',
  COMMANDS_62_22V3 = 'commands_62_22v3',
  COMMANDS_63_22V3 = 'commands_63_22v3',
  URGE_2_22V3 = 'urge_2_22v3',
  POTTY_22V3 = 'potty_22v3',
  BEHAVIOR_2_22V3 = 'behavior_2_22v3',
  TRAINING_22V3 = 'training_22v3',
  DOG_STATISTICS_22V3 = 'dog_statistics_22v3',
  EMAIL_22V3 = 'email_22v3',
  NEWSLETTER_URGE_22V3 = 'newsletter_urge_22v3',
  LAST_CHANCE_OFFER_22V3 = 'last_chance_offer_22v3',
  LAST_CHANCE_OFFER_2_22V3 = 'last_chance_offer_2_22v3',
  SUBSCRIPTIONS_22V3 = 'subscriptions_22v3',
  PAYMENT_22V3 = 'payment_22v3',
  CANCEL_OFFER_22V3 = 'cancel_offer_22v3',
  CHAT_UPSELL_22V3 = 'chat_upsell_22v3',
  UPSELL_22V3 = 'upsell_22v3',
  UPSELL_FEEDING_GUIDE_22V3 = 'upsell_feeding_guide_22v3',
  UPSELL_EMOTIONAL_SUPPORT_22V3 = 'upsell_emotional_support_22v3',
  UPSELL_PITPAT_22V3 = 'upsell_pitpat_22v3',
  DOWNLOAD_22V3 = 'download_22v3',

  // woofz_rfnd3
  SEX_RFND3 = 'sex_rfnd3',
  DOG_AGE_RFND3 = 'dog_age_rfnd3',
  DOG_BREED_RFND3 = 'dog_breed_rfnd3',
  URGE_RFND3 = 'urge_rfnd3',
  COMMANDS_61_RFND3 = 'commands_61_rfnd3',
  COMMANDS_62_RFND3 = 'commands_62_rfnd3',
  COMMANDS_63_RFND3 = 'commands_63_rfnd3',
  URGE_RFND3_2 = 'urge_rfnd3_2',
  POTTY_RFND3 = 'potty_rfnd3',
  BEHAVIOR_RFND3 = 'behavior_rfnd3',
  TRAINING_RFND3 = 'training_rfnd3',
  PREPARE_FLOW_RFND3 = 'prepare_flow_rfnd3',
  DOG_STATISTICS_RFND3 = 'dog_statistics_rfnd3',
  EMAIL_RFND3 = 'email_rfnd3',
  NEWSLETTER_URGE_RFND3 = 'newsletter_urge_rfnd3',
  LAST_CHANCE_OFFER_RFND3 = 'last_chance_offer_rfnd3',
  SUBSCRIPTIONS_RFND3 = 'subscriptions_rfnd3',
  CANCEL_OFFER_RFND3 = 'cancel_offer_rfnd3',
  CHAT_UPSELL_RFND3 = 'chat_upsell_rfnd3',
  UPSELL_RFND3 = 'upsell_1_rfnd3',
  DOWNLOAD_RFND3 = 'download_rfnd3',

  // woofz_ppp
  DOG_AGE_WOOFZ_PPP = 'dog_age_woofz_ppp',
  DOG_OWNER_WOOFZ_PPP = 'dog_owner_woofz_ppp',
  TRAINING_COMMANDS_WOOFZ_PPP = 'training_commands_woofz_ppp',
  URGE_WOOFZ_PPP = 'urge_woofz_ppp',
  DOG_BREED_WOOFZ_PPP = 'dog_breed_woofz_ppp',
  FACING_CHALLENGES_WOOFZ_PPP = 'facing_challenges_woofz_ppp',
  FACING_CHALLENGES_2_WOOFZ_PPP = 'facing_challenges_2_woofz_ppp',
  BEHAVIOR_FREQUENCY_WOOFZ_PPP = 'behavior_frequency_woofz_ppp',
  URGE_PROGRAM_WOOFZ_PPP = 'urge_program_woofz_ppp',
  BEHAVIOR_FEELINGS_WOOFZ_PPP = 'behavior_feelings_woofz_ppp',
  FIX_BEHAVIOR_WOOFZ_PPP = 'fix_behavior_woofz_ppp',
  URGE_4_WOOFZ_PPP = 'urge_4_woofz_ppp',
  COMMANDS_WOOFZ_PPP = 'commands_woofz_ppp',
  PARENT_GOAL_WOOFZ_PPP = 'parent_goal_woofz_ppp',
  TRAINING_PLACE_WOOFZ_PPP = 'training_place_woofz_ppp',
  TRAINING_FREQUENCY_WOOFZ_PPP = 'training_frequency_woofz_ppp',
  URGE_5_WOOFZ_PPP = 'urge_5_woofz_ppp',
  PREPARE_FLOW_WOOFZ_PPP = 'prepare_flow_woofz_ppp',
  EMAIL_WOOFZ_PPP = 'email_woofz_ppp',
  NEWSLETTER_URGE_WOOFZ_PPP = 'newsletter_urge_woofz_ppp',
  LAST_CHANCE_OFFER_WOOFZ_PPP = 'last_chance_offer_woofz_ppp',
  WELCOME_TO_WOOFZ_WOOFZ_PPP = 'welcome_to_woofz_woofz_ppp',
  SUBSCRIPTIONS_WOOFZ_PPP = 'subscriptions_woofz_ppp',
  CHAT_UPSELL_WOOFZ_PPP = 'chat_upsell_woofz_ppp',
  UPSELL_WOOFZ_PPP = 'upsell_woofz_ppp',
  UPSELL_FEEDING_GUIDE_WOOFZ_PPP = 'upsell_feeding_guide_woofz_ppp',
  UPSELL_EMOTIONAL_SUPPORT_WOOFZ_PPP = 'upsell_emotional_support_woofz_ppp',
  DOWNLOAD_WOOFZ_PPP = 'download_woofz_ppp',

  // woofz_ppp_bl
  DOG_AGE_WOOFZ_PPP_BL = 'dog_age_woofz_ppp_bl',
  DOG_OWNER_WOOFZ_PPP_BL = 'dog_owner_woofz_ppp_bl',
  TRAINING_COMMANDS_WOOFZ_PPP_BL = 'training_commands_woofz_ppp_bl',
  URGE_WOOFZ_PPP_BL = 'urge_woofz_ppp_bl',
  DOG_BREED_WOOFZ_PPP_BL = 'dog_breed_woofz_ppp_bl',
  FACING_CHALLENGES_WOOFZ_PPP_BL = 'facing_challenges_woofz_ppp_bl',
  FACING_CHALLENGES_2_WOOFZ_PPP_BL = 'facing_challenges_2_woofz_ppp_bl',
  BEHAVIOR_FREQUENCY_WOOFZ_PPP_BL = 'behavior_frequency_woofz_ppp_bl',
  URGE_PROGRAM_WOOFZ_PPP_BL = 'urge_program_woofz_ppp_bl',
  BEHAVIOR_FEELINGS_WOOFZ_PPP_BL = 'behavior_feelings_woofz_ppp_bl',
  FIX_BEHAVIOR_WOOFZ_PPP_BL = 'fix_behavior_woofz_ppp_bl',
  URGE_4_WOOFZ_PPP_BL = 'urge_4_woofz_ppp_bl',
  COMMANDS_WOOFZ_PPP_BL = 'commands_woofz_ppp_bl',
  PARENT_GOAL_WOOFZ_PPP_BL = 'parent_goal_woofz_ppp_bl',
  TRAINING_PLACE_WOOFZ_PPP_BL = 'training_place_woofz_ppp_bl',
  TRAINING_FREQUENCY_WOOFZ_PPP_BL = 'training_frequency_woofz_ppp_bl',
  URGE_5_WOOFZ_PPP_BL = 'urge_5_woofz_ppp_bl',
  PREPARE_FLOW_WOOFZ_PPP_BL = 'prepare_flow_woofz_ppp_bl',
  COMMITMENT_SCREEN_PPP_BL = 'commitment_screen_ppp_bl',
  EMAIL_WOOFZ_PPP_BL = 'email_woofz_ppp_bl',
  NEWSLETTER_URGE_WOOFZ_PPP_BL = 'newsletter_urge_woofz_ppp_bl',
  LAST_CHANCE_OFFER_WOOFZ_PPP_BL = 'last_chance_offer_woofz_ppp_bl',
  SUBSCRIPTIONS_WOOFZ_PPP_BL = 'subscriptions_woofz_ppp_bl',
  CHAT_UPSELL_WOOFZ_PPP_BL = 'chat_upsell_woofz_ppp_bl',
  UPSELL_WOOFZ_PPP_BL = 'upsell_woofz_ppp_bl',
  UPSELL_FEEDING_GUIDE_WOOFZ_PPP_BL = 'upsell_feeding_guide_woofz_ppp_bl',
  UPSELL_EMOTIONAL_SUPPORT_WOOFZ_PPP_BL = 'upsell_emotional_support_woofz_ppp_bl',
  DOWNLOAD_WOOFZ_PPP_BL = 'download_woofz_ppp_bl',

  // woofz_ppp_woofy
  DOG_AGE_WOOFZ_PPP_WOOFY = 'dog_age_woofz_ppp_woofy',
  DOG_OWNER_WOOFZ_PPP_WOOFY = 'dog_owner_woofz_ppp_woofy',
  TRAINING_COMMANDS_WOOFZ_PPP_WOOFY = 'training_commands_woofz_ppp_woofy',
  URGE_WOOFZ_PPP_WOOFY = 'urge_woofz_ppp_woofy',
  DOG_BREED_WOOFZ_PPP_WOOFY = 'dog_breed_woofz_ppp_woofy',
  FACING_CHALLENGES_WOOFZ_PPP_WOOFY = 'facing_challenges_woofz_ppp_woofy',
  FACING_CHALLENGES_2_WOOFZ_PPP_WOOFY = 'facing_challenges_2_woofz_ppp_woofy',
  BEHAVIOR_FREQUENCY_WOOFZ_PPP_WOOFY = 'behavior_frequency_woofz_ppp_woofy',
  URGE_PROGRAM_WOOFZ_PPP_WOOFY = 'urge_program_woofz_ppp_woofy',
  BEHAVIOR_FEELINGS_WOOFZ_PPP_WOOFY = 'behavior_feelings_woofz_ppp_woofy',
  FIX_BEHAVIOR_WOOFZ_PPP_WOOFY = 'fix_behavior_woofz_ppp_woofy',
  URGE_4_WOOFZ_PPP_WOOFY = 'urge_4_woofz_ppp_woofy',
  COMMANDS_WOOFZ_PPP_WOOFY = 'commands_woofz_ppp_woofy',
  PARENT_GOAL_WOOFZ_PPP_WOOFY = 'parent_goal_woofz_ppp_woofy',
  TRAINING_PLACE_WOOFZ_PPP_WOOFY = 'training_place_woofz_ppp_woofy',
  TRAINING_FREQUENCY_WOOFZ_PPP_WOOFY = 'training_frequency_woofz_ppp_woofy',
  URGE_5_WOOFZ_PPP_WOOFY = 'urge_5_woofz_ppp_woofy',
  PREPARE_FLOW_WOOFZ_PPP_WOOFY = 'prepare_flow_woofz_ppp_woofy',
  EMAIL_WOOFZ_PPP_WOOFY = 'email_woofz_ppp_woofy',
  NEWSLETTER_URGE_WOOFZ_PPP_WOOFY = 'newsletter_urge_woofz_ppp_woofy',
  LAST_CHANCE_OFFER_WOOFZ_PPP_WOOFY = 'last_chance_offer_woofz_ppp_woofy',
  SUBSCRIPTIONS_WOOFZ_PPP_WOOFY = 'subscriptions_woofz_ppp_woofy',
  CHAT_UPSELL_WOOFZ_PPP_WOOFY = 'chat_upsell_woofz_ppp_woofy',
  CHAT_WOOFZ_PPP_WOOFY = 'chat_woofz_ppp_woofy',
  ACCOUNT_WOOFY_WOOFZ_PPP_WOOFY = 'account_woofy_woofz_ppp_woofy',
  DOWNLOAD_WOOFY_WOOFZ_PPP_WOOFY = 'download_woofy_woofz_ppp_woofy',
  DOWNLOAD_WOOFZ_PPP_WOOFY = 'download_woofz_ppp_woofy',

  // vc6
  SEX_VC6 = 'sex_vc6',
  DOG_AGE_VC6 = 'dog_age_vc6',
  SHELTER_VC6 = 'shelter_vc6',
  DOG_BREED_VC6 = 'dog_breed_vc6',
  BEHAVIOR_VC6 = 'behavior_vc6',
  HEALTH_ISSUES_VC6 = 'health_issues_vc6',
  GOALS_QUESTION_VC6 = 'goals_question_vc6',
  URGE_VC6 = 'urge_vc6',
  FEED_VC6 = 'feed_vc6',
  WALK_VC6 = 'walk_vc6',
  STRESS_VC6 = 'stress_vc6',
  HOME_ALONG_VC6 = 'home_along_vc6',
  ACTIVITY_VC6 = 'activity_vc6',
  DESCRIBE_VC6 = 'describe_vc6',
  ALMOST_DONE_VC6 = 'almost_done_vc6',
  TRAINER_IS_READY_VC6 = 'trainer_is_ready_vc6',
  DOG_SUMMARY_VC6 = 'dog_summary_vc6',
  FEATURE_DESCRIPTION_VC6 = 'feature_description_vc6',
  CYNOLOGISTS_VC6 = 'cynologists_vc6',
  OUR_MISSION_VC6 = 'our_mission_vc6',
  LIMITED_OFFER_VC6 = 'limited_offer_vc6',
  SUBSCRIPTIONS_TRIAL_PRICE_VC6 = 'subscriptions_trial_price_vc6',
  SUBSCRIPTIONS_TRIAL_PRICE_2_VC6 = 'subscriptions_trial_price_2_vc6',
  CALENDLY_VC6 = 'calendly_vc6',
  ALL_SET_VC6 = 'all_set_vc6',

  // woofz_easter_65
  SUBSCRIPTIONS_EASTER_65 = 'subscriptions_easter_65',
  CHAT_UPSELL_EASTER_65 = 'chat_upsell_easter_65',
  UPSELL_EASTER_65 = 'upsell_easter_65',
  DOWNLOAD_EASTER_65 = 'download_easter_65',

  // woofz_easter_70
  SUBSCRIPTIONS_EASTER_70 = 'subscriptions_easter_70',
  CHAT_UPSELL_EASTER_70 = 'chat_upsell_easter_70',
  UPSELL_EASTER_70 = 'upsell_easter_70',
  DOWNLOAD_EASTER_70 = 'download_easter_70',

  // woofz_easter_75
  SUBSCRIPTIONS_EASTER_75 = 'subscriptions_easter_75',
  CHAT_UPSELL_EASTER_75 = 'chat_upsell_easter_75',
  UPSELL_EASTER_75 = 'upsell_easter_75',
  DOWNLOAD_EASTER_75 = 'download_easter_75',

  // woofz_easter_80
  SUBSCRIPTIONS_EASTER_80 = 'subscriptions_easter_80',
  CHAT_UPSELL_EASTER_80 = 'chat_upsell_easter_80',
  UPSELL_EASTER_80 = 'upsell_easter_80',
  DOWNLOAD_EASTER_80 = 'download_easter_80',

  // woofz_ppday_65
  SUBSCRIPTIONS_PPDAY_65_N = 'subscriptions_ppday_65_n',
  CHAT_UPSELL_PPDAY_65 = 'chat_upsell_ppday_65',
  UPSELL_PPDAY_65 = 'upsell_ppday_65',
  DOWNLOAD_PPDAY_65 = 'download_ppday_65',

  // woofz_ppday_70
  SUBSCRIPTIONS_PPDAY_70_N = 'subscriptions_ppday_70_n',
  CHAT_UPSELL_PPDAY_70 = 'chat_upsell_ppday_70',
  UPSELL_PPDAY_70 = 'upsell_ppday_70',
  DOWNLOAD_PPDAY_70 = 'download_ppday_70',

  // woofz_ppday_75
  SUBSCRIPTIONS_PPDAY_75_N = 'subscriptions_ppday_75_n',
  CHAT_UPSELL_PPDAY_75 = 'chat_upsell_ppday_75',
  UPSELL_PPDAY_75 = 'upsell_ppday_75',
  DOWNLOAD_PPDAY_75 = 'download_ppday_75',

  // woofz_ppday_80
  SUBSCRIPTIONS_PPDAY_80_N = 'subscriptions_ppday_80_n',
  CHAT_UPSELL_PPDAY_80 = 'chat_upsell_ppday_80',
  UPSELL_PPDAY_80 = 'upsell_ppday_80',
  DOWNLOAD_PPDAY_80 = 'download_ppday_80',

  // woofz_offer1_65
  SUBSCRIPTIONS_OFFER1_65 = 'subscriptions_offer1_65',
  CHAT_UPSELL_OFFER1_65 = 'chat_upsell_offer1_65',
  UPSELL_OFFER1_65 = 'upsell_offer1_65',
  DOWNLOAD_OFFER1_65 = 'download_offer1_65',

  // woofz_offer1_70
  SUBSCRIPTIONS_OFFER1_70 = 'subscriptions_offer1_70',
  CHAT_UPSELL_OFFER1_70 = 'chat_upsell_offer1_70',
  UPSELL_OFFER1_70 = 'upsell_offer1_70',
  DOWNLOAD_OFFER1_70 = 'download_offer1_70',

  // woofz_offer1_75
  SUBSCRIPTIONS_OFFER1_75 = 'subscriptions_offer1_75',
  CHAT_UPSELL_OFFER1_75 = 'chat_upsell_offer1_75',
  UPSELL_OFFER1_75 = 'upsell_offer1_75',
  DOWNLOAD_OFFER1_75 = 'download_offer1_75',

  // woofz_offer1_80
  SUBSCRIPTIONS_OFFER1_80 = 'subscriptions_offer1_80',
  CHAT_UPSELL_OFFER1_80 = 'chat_upsell_offer1_80',
  UPSELL_OFFER1_80 = 'upsell_offer1_80',
  DOWNLOAD_OFFER1_80 = 'download_offer1_80',

  // woofz_offer2_70
  SUBSCRIPTIONS_OFFER2_70 = 'subscriptions_offer2_70',
  CHAT_UPSELL_OFFER2_70 = 'chat_upsell_offer2_70',
  UPSELL_OFFER2_70 = 'upsell_offer2_70',
  DOWNLOAD_OFFER2_70 = 'download_offer2_70',

  // woofz_offer2_75
  SUBSCRIPTIONS_OFFER2_75 = 'subscriptions_offer2_75',
  CHAT_UPSELL_OFFER2_75 = 'chat_upsell_offer2_75',
  UPSELL_OFFER2_75 = 'upsell_offer2_75',
  DOWNLOAD_OFFER2_75 = 'download_offer2_75',

  // woofz_xmas_65
  SUBSCRIPTIONS_XMAS_65 = 'subscriptions_xmas_65',
  CHAT_UPSELL_XMAS_65 = 'chat_upsell_xmas_65',
  UPSELL_XMAS_65 = 'upsell_xmas_65',
  DOWNLOAD_XMAS_65 = 'download_xmas_65',

  // woofz_xmas_70
  SUBSCRIPTIONS_XMAS_70 = 'subscriptions_xmas_70',
  CHAT_UPSELL_XMAS_70 = 'chat_upsell_xmas_70',
  UPSELL_XMAS_70 = 'upsell_xmas_70',
  DOWNLOAD_XMAS_70 = 'download_xmas_70',

  // woofz_xmas_80
  SUBSCRIPTIONS_XMAS_80 = 'subscriptions_xmas_80',
  CHAT_UPSELL_XMAS_80 = 'chat_upsell_xmas_80',
  UPSELL_XMAS_80 = 'upsell_xmas_80',
  DOWNLOAD_XMAS_80 = 'download_xmas_80',

  // woofz_npday_65
  SUBSCRIPTIONS_NPDAY_65 = 'subscriptions_npday_65',
  CHAT_UPSELL_NPDAY_65 = 'chat_upsell_npday_65',
  UPSELL_NPDAY_65 = 'upsell_npday_65',
  DOWNLOAD_NPDAY_65 = 'download_npday_65',

  // woofz_npday_70
  SUBSCRIPTIONS_NPDAY_70 = 'subscriptions_npday_70',
  CHAT_UPSELL_NPDAY_70 = 'chat_upsell_npday_70',
  UPSELL_NPDAY_70 = 'upsell_npday_70',
  DOWNLOAD_NPDAY_70 = 'download_npday_70',

  // woofz_npday_75
  SUBSCRIPTIONS_NPDAY_75 = 'subscriptions_npday_75',
  CHAT_UPSELL_NPDAY_75 = 'chat_upsell_npday_75',
  UPSELL_NPDAY_75 = 'upsell_npday_75',
  DOWNLOAD_NPDAY_75 = 'download_npday_75',

  // woofz_npday_80
  SUBSCRIPTIONS_NPDAY_80 = 'subscriptions_npday_80',
  CHAT_UPSELL_NPDAY_80 = 'chat_upsell_npday_80',
  UPSELL_NPDAY_80 = 'upsell_npday_80',
  DOWNLOAD_NPDAY_80 = 'download_npday_80',

  // woofz_nrday_65
  SUBSCRIPTIONS_NRDAY_65_N = 'subscriptions_nrday_65_n',
  CHAT_UPSELL_NRDAY_65 = 'chat_upsell_nrday_65',
  UPSELL_NRDAY_65 = 'upsell_nrday_65',
  DOWNLOAD_NRDAY_65 = 'download_nrday_65',

  // woofz_nrday_70
  SUBSCRIPTIONS_NRDAY_70_N = 'subscriptions_nrday_70_n',
  CHAT_UPSELL_NRDAY_70 = 'chat_upsell_nrday_70',
  UPSELL_NRDAY_70 = 'upsell_nrday_70',
  DOWNLOAD_NRDAY_70 = 'download_nrday_70',

  // woofz_nrday_75
  SUBSCRIPTIONS_NRDAY_75_N = 'subscriptions_nrday_75_n',
  CHAT_UPSELL_NRDAY_75 = 'chat_upsell_nrday_75',
  UPSELL_NRDAY_75 = 'upsell_nrday_75',
  DOWNLOAD_NRDAY_75 = 'download_nrday_75',

  // woofz_nrday_80
  SUBSCRIPTIONS_NRDAY_80_N = 'subscriptions_nrday_80_n',
  CHAT_UPSELL_NRDAY_80 = 'chat_upsell_nrday_80',
  UPSELL_NRDAY_80 = 'upsell_nrday_80',
  DOWNLOAD_NRDAY_80 = 'download_nrday_80',

  // woofz_pt1
  DOG_SEX_PT1 = 'dog_sex_pt1',
  DOG_AGE_PT1 = 'dog_age_pt1',
  SHELTER_PT1 = 'shelter_pt1',
  DOG_BREED_PT1 = 'dog_breed_pt1',
  URGE_PT1 = 'urge_pt1',
  STARTED_PT1 = 'started_pt1',
  PLACE_PT1 = 'place_pt1',
  GOALS_PT1 = 'goals_pt1',
  ACCIDENTS_PT1 = 'accidents_pt1',
  CONCERNS_PT1 = 'concerns_pt1',
  URGE_2_PT1 = 'urge_2_pt1',
  LIVING_SITUATION_PT1 = 'living_situation_pt1',
  POTTY_BREAKS_PT1 = 'potty_breaks_pt1',
  CRATE_TRAINING_PT1 = 'crate_training_pt1',
  BEHAVIOR_PT1 = 'behavior_pt1',
  TRAINING_TIME_PT1 = 'training_time_pt1',
  COMMANDS_PT1 = 'commands_pt1',
  PREPARE_FLOW_PT1 = 'prepare_flow_pt1',
  COMMITMENT_SCREEN_PT1 = 'commitment_screen_pt1',
  EMAIL_PT1 = 'email_pt1',
  NEWSLETTER_URGE_PT1 = 'newsletter_urge_pt1',
  SUBSCRIPTIONS_PT1 = 'subscriptions_pt1',
  CANCEL_OFFER_PT1 = 'cancel_offer_pt1',
  CHAT_UPSELL_PT1 = 'chat_upsell_pt1',
  UPSELL_PT1 = 'upsell_pt1',
  UPSELL_FEEDING_GUIDE_PT1 = 'upsell_feeding_guide_pt1',
  UPSELL_EMOTIONAL_SUPPORT_PT1 = 'upsell_emotional_support_pt1',
  DOWNLOAD_PT1 = 'download_pt1',

  // woofz_pt1_bg
  DOG_SEX_PT1_BG = 'dog_sex_pt1_bg',
  DOG_AGE_PT1_BG = 'dog_age_pt1_bg',
  SHELTER_PT1_BG = 'shelter_pt1_bg',
  DOG_BREED_PT1_BG = 'dog_breed_pt1_bg',
  URGE_PT1_BG = 'urge_pt1_bg',
  STARTED_PT1_BG = 'started_pt1_bg',
  PLACE_PT1_BG = 'place_pt1_bg',
  GOALS_PT1_BG = 'goals_pt1_bg',
  ACCIDENTS_PT1_BG = 'accidents_pt1_bg',
  CONCERNS_PT1_BG = 'concerns_pt1_bg',
  URGE_2_PT1_BG = 'urge_2_pt1_bg',
  LIVING_SITUATION_PT1_BG = 'living_situation_pt1_bg',
  POTTY_BREAKS_PT1_BG = 'potty_breaks_pt1_bg',
  CRATE_TRAINING_PT1_BG = 'crate_training_pt1_bg',
  COMMANDS_PT1_BG = 'commands_pt1_bg',
  TRAINING_TIME_PT1_BG = 'training_time_pt1_bg',
  PREPARE_FLOW_PT1_BG = 'prepare_flow_pt1_bg',
  COMMITMENT_SCREEN_PT1_BG = 'commitment_screen_pt1_bg',
  EMAIL_PT1_BG = 'email_pt1_bg',
  NEWSLETTER_URGE_PT1_BG = 'newsletter_urge_pt1_bg',
  SUBSCRIPTIONS_PT1_BG = 'subscriptions_pt1_bg',
  CANCEL_OFFER_PT1_BG = 'cancel_offer_pt1_bg',
  CHAT_UPSELL_PT1_BG = 'chat_upsell_pt1_bg',
  UPSELL_PT1_BG = 'upsell_pt1_bg',
  UPSELL_FEEDING_GUIDE_PT1_BG = 'upsell_feeding_guide_pt1_bg',
  UPSELL_EMOTIONAL_SUPPORT_PT1_BG = 'upsell_emotional_support_pt1_bg',
  DOWNLOAD_PT1_BG = 'download_pt1_bg',

  // woofz22_v4
  SEX_22V4 = 'sex_22v4',
  DOG_AGE_22V4 = 'dog_age_22v4',
  DOG_BREED_22V4 = 'dog_breed_22v4',
  DOG_BREED_ID_22V4 = 'dog_breed_id_22v4',
  URGE_22V4 = 'urge_5_22v4',
  COMMANDS_61_22V4 = 'commands_61_22v4',
  COMMANDS_62_22V4 = 'commands_62_22v4',
  COMMANDS_63_22V4 = 'commands_63_22v4',
  URGE_2_22V4 = 'urge_2_22v4',
  POTTY_22V4 = 'potty_22v4',
  BEHAVIOR_22V4 = 'behavior_22v4',
  TRAINING_22V4 = 'training_22v4',
  PREPARE_FLOW_22V4 = 'prepare_flow_22v4',
  DOG_STATISTICS_22V4 = 'dog_statistics_22v4',
  EMAIL_22V4 = 'email_22v4',
  NEWSLETTER_URGE_22V4 = 'newsletter_urge_22v4',
  LAST_CHANCE_OFFER_22V4 = 'last_chance_offer_22v4',
  WELCOME_TO_WOOFZ_22V4 = 'welcome_to_woofz_22v4',
  SUBSCRIPTIONS_22V4 = 'subscriptions_22v4',
  CANCEL_OFFER_22V4 = 'cancel_offer_22v4',
  CHAT_UPSELL_22V4 = 'chat_upsell_22v4',
  UPSELL_22V4 = 'upsell_22v4',
  ROVER_UPSELL_22V4 = 'rover_upsell_22v4',
  UPSELL_FEEDING_GUIDE_22V4 = 'upsell_feeding_guide_22v4',
  UPSELL_EMOTIONAL_SUPPORT_22V4 = 'upsell_emotional_support_22v4',
  DOWNLOAD_22V4 = 'download_22v4',

  // woofz22_v4_bg
  SEX_22V4_BG = 'sex_22v4_bg',
  DOG_AGE_22V4_BG = 'dog_age_22v4_bg',
  DOG_BREED_22V4_BG = 'dog_breed_22v4_bg',
  DOG_BREED_ID_22V4_BG = 'dog_breed_id_22v4_bg',
  URGE_22V4_BG = 'urge_5_22v4_bg',
  COMMANDS_61_22V4_BG = 'commands_61_22v4_bg',
  COMMANDS_62_22V4_BG = 'commands_62_22v4_bg',
  COMMANDS_63_22V4_BG = 'commands_63_22v4_bg',
  URGE_2_22V4_BG = 'urge_2_22v4_bg',
  POTTY_22V4_BG = 'potty_22v4_bg',
  BEHAVIOR_22V4_BG = 'behavior_22v4_bg',
  TRAINING_22V4_BG = 'training_22v4_bg',
  PREPARE_FLOW_22V4_BG = 'prepare_flow_22v4_bg',
  DOG_STATISTICS_22V4_BG = 'dog_statistics_22v4_bg',
  EMAIL_22V4_BG = 'email_22v4_bg',
  NEWSLETTER_URGE_22V4_BG = 'newsletter_urge_22v4_bg',
  LAST_CHANCE_OFFER_22V4_BG = 'last_chance_offer_22v4_bg',
  WELCOME_TO_WOOFZ_22V4_BG = 'welcome_to_woofz_22v4_bg',
  SUBSCRIPTIONS_22V4_BG = 'subscriptions_22v4_bg',
  CANCEL_OFFER_22V4_BG = 'cancel_offer_22v4_bg',
  CHAT_UPSELL_22V4_BG = 'chat_upsell_22v4_bg',
  UPSELL_22V4_BG = 'upsell_22v4_bg',
  UPSELL_FEEDING_GUIDE_22V4_BG = 'upsell_feeding_guide_22v4_bg',
  UPSELL_EMOTIONAL_SUPPORT_22V4_BG = 'upsell_emotional_support_22v4_bg',
  DOWNLOAD_22V4_BG = 'download_22v4_bg',

  // woofz22_v4t
  SEX_22V4T = 'sex_22v4t',
  DOG_AGE_22V4T = 'dog_age_22v4t',
  DOG_BREED_22V4T = 'dog_breed_22v4t',
  URGE_22V4T = 'urge_5_22v4t',
  COMMANDS_61_22V4T = 'commands_61_22v4t',
  COMMANDS_62_22V4T = 'commands_62_22v4t',
  COMMANDS_63_22V4T = 'commands_63_22v4t',
  URGE_2_22V4T = 'urge_2_22v4t',
  POTTY_22V4T = 'potty_22v4t',
  BEHAVIOR_22V4T = 'behavior_22v4t',
  TRAINING_22V4T = 'training_22v4t',
  PREPARE_FLOW_22V4T = 'prepare_flow_22v4t',
  DOG_STATISTICS_22V4T = 'dog_statistics_22v4t',
  EMAIL_22V4T = 'email_22v4t',
  NEWSLETTER_URGE_22V4T = 'newsletter_urge_22v4t',
  LAST_CHANCE_OFFER_22V4T = 'last_chance_offer_22v4t',
  SUBSCRIPTIONS_22V4T = 'subscriptions_22v4t',
  CANCEL_OFFER_22V4T = 'cancel_offer_22v4t',
  CHAT_UPSELL_22V4T = 'chat_upsell_22v4t',
  UPSELL_22V4T = 'upsell_22v4t',
  DOWNLOAD_22V4T = 'download_22v4t',

  // woofz22_v4_wt
  SEX_22V4_WT = 'sex_22v4_wt',
  DOG_AGE_22V4_WT = 'dog_age_22v4_wt',
  DOG_BREED_22V4_WT = 'dog_breed_22v4_wt',
  DOG_BREED_ID_22V4_WT = 'dog_breed_id_22v4_wt',
  URGE_22V4_WT = 'urge_5_22v4_wt',
  COMMANDS_61_22V4_WT = 'commands_61_22v4_wt',
  COMMANDS_62_22V4_WT = 'commands_62_22v4_wt',
  COMMANDS_63_22V4_WT = 'commands_63_22v4_wt',
  URGE_2_22V4_WT = 'urge_2_22v4_wt',
  POTTY_22V4_WT = 'potty_22v4_wt',
  BEHAVIOR_22V4_WT = 'behavior_22v4_wt',
  TRAINING_22V4_WT = 'training_22v4_wt',
  PREPARE_FLOW_22V4_WT = 'prepare_flow_22v4_wt',
  DOG_STATISTICS_22V4_WT = 'dog_statistics_22v4_wt',
  EMAIL_22V4_WT = 'email_22v4_wt',
  NEWSLETTER_URGE_22V4_WT = 'newsletter_urge_22v4_wt',
  LAST_CHANCE_OFFER_22V4_WT = 'last_chance_offer_22v4_wt',
  WELCOME_TO_WOOFZ_22V4_WT = 'welcome_to_woofz_22v4_wt',
  SUBSCRIPTIONS_22V4_WT = 'subscriptions_22v4_wt',
  CANCEL_OFFER_22V4_WT = 'cancel_offer_22v4_wt',
  CHAT_UPSELL_22V4_WT = 'chat_upsell_22v4_wt',
  UPSELL_22V4_WT = 'upsell_22v4_wt',
  UPSELL_FEEDING_GUIDE_22V4_WT = 'upsell_feeding_guide_22v4_wt',
  UPSELL_EMOTIONAL_SUPPORT_22V4_WT = 'upsell_emotional_support_22v4_wt',
  DOWNLOAD_22V4_WT = 'download_22v4_wt',

  // woofz_pup_new
  DOG_AGE_PUP = 'dog_age_pup',
  DOG_OWNER_PUP = 'dog_owner_pup',
  TRAINING_COMMANDS_PUP = 'training_commands_pup',
  URGE_PAGE_PUP = 'urge_page_pup',
  DOG_BREED_PUP = 'dog_breed_pup',
  FACING_CHALLENGES_PUP = 'facing_challenges_pup',
  FACING_CHALLENGES_2_PUP = 'facing_challenges_2_pup',
  BEHAVIOR_FREQUENCY_PUP = 'behavior_frequency_pup',
  URGE_PROGRAM_PUP = 'urge_program_pup',
  BEHAVIOR_FEELINGS_PUP = 'behavior_feelings_pup',
  FIX_BEHAVIOR_PUP = 'fix_behavior_pup',
  URGE_PAGE_4_PUP = 'urge_page_4_pup',
  COMMANDS_PUP = 'commands_pup',
  PARENT_GOAL_PUP = 'parent_goal_pup',
  TRAINING_PLACE_PUP = 'training_place_pup',
  TRAINING_FREQUENCY_PUP = 'training_frequency_pup',
  URGE_PAGE_5_PUP = 'urge_page_5_pup',
  PREPARE_FLOW_PUP = 'prepare_flow_pup',
  EMAIL_PUP = 'email_pup',
  NEWSLETTER_URGE_PUP = 'newsletter_urge_pup',
  LAST_CHANCE_OFFER_PUP = 'last_chance_offer_pup',
  SUBSCRIPTIONS_PUP = 'subscriptions_pup',
  CHAT_UPSELL_PUP = 'chat_upsell_pup',
  UPSELL_PUP = 'upsell_pup',
  UPSELL_FEEDING_GUIDE_PUP = 'upsell_feeding_guide_pup',
  UPSELL_EMOTIONAL_SUPPORT_PUP = 'upsell_emotional_support_pup',
  DOWNLOAD_PUP = 'download_pup',

  // woofz_wa1
  SUBSCRIPTIONS_WA1 = 'subscriptions_wa1',
  CANCEL_OFFER_WA1 = 'cancel_offer_wa1',
  DOWNLOAD_WA1 = 'download_wa1',

  // woofz_s1_6_12
  DOG_BREED_S1_6_12 = 'dog_breed_s1_6_12',
  DOG_AGE_S1_6_12 = 'dog_age_s1_6_12',
  SHELTER_S1_6_12 = 'shelter_s1_6_12',
  COMMANDS_S1_6_12 = 'commands_s1_6_12',
  SUBSCRIPTIONS_S1_6_12 = 'subscriptions_s1_6_12',
  CHAT_UPSELL_S1_6_12 = 'chat_upsell_s1_6_12',
  UPSELL_1_S1_6_12 = 'upsell_1_s1_6_12',
  DOWNLOAD_S1_6_12 = 'download_s1_6_12',

  // woofz_s2_6_12
  DOG_BREED_S2_6_12 = 'dog_breed_s2_6_12',
  DOG_AGE_S2_6_12 = 'dog_age_s2_6_12',
  SHELTER_S2_6_12 = 'shelter_s2_6_12',
  COMMANDS_S2_6_12 = 'commands_s2_6_12',
  SUBSCRIPTIONS_S2_6_12 = 'subscriptions_s2_6_12',
  CHAT_UPSELL_S2_6_12 = 'chat_upsell_s2_6_12',
  UPSELL_1_S2_6_12 = 'upsell_1_s2_6_12',
  DOWNLOAD_S2_6_12 = 'download_s2_6_12',

  // woofz_s3_6_12
  DOG_BREED_S3_6_12 = 'dog_breed_s3_6_12',
  DOG_AGE_S3_6_12 = 'dog_age_s3_6_12',
  SHELTER_S3_6_12 = 'shelter_s3_6_12',
  COMMANDS_S3_6_12 = 'commands_s3_6_12',
  SUBSCRIPTIONS_S3_6_12 = 'subscriptions_s3_6_12',
  CHAT_UPSELL_S3_6_12 = 'chat_upsell_s3_6_12',
  UPSELL_1_S3_6_12 = 'upsell_1_s3_6_12',
  DOWNLOAD_S3_6_12 = 'download_s3_6_12',

  // woofz_rt
  SEX_RT_2_RTV2 = 'sex_rt_2_rtv2',
  DOG_AGE_RT_RTV2 = 'dog_age_rt_rtv2',
  URGE_RT_V1_RTV2 = 'urge_rt_v1_rtv2',
  CHALLENGES_RT_RTV2 = 'challenges_rt_rtv2',
  WALKS_FEEL_RTV2 = 'walks_feel_rtv2',
  DOG_EXCITEMENTS_TRIGGERS_RTV2 = 'dog_excitements_triggers_rtv2',
  URGE_RT_5_RTV2 = 'urge_rt_5_rtv2',
  DOG_MISBEHAVES_RTV2 = 'dog_misbehaves_rtv2',
  DOG_ACT_RT_RTV2 = 'dog_act_rt_rtv2',
  DOG_OFF_AT_HOME_RTV2 = 'dog_off_at_home_rtv2',
  URGE_RT_6_RTV2 = 'urge_rt_6_rtv2',
  ACCESS_TO_FOOD_RTV2 = 'access_to_food_rtv2',
  URGE_RT_7_RTV2 = 'urge_rt_7_rtv2',
  DOG_AGGRESSIVE_RT_RTV2 = 'dog_aggressive_rt_rtv2',
  DOG_CALM_DOWN_RT_RTV2 = 'dog_calm_down_rt_rtv2',
  URGE_RT_8_RTV2 = 'urge_rt_8_rtv2',
  DOG_BREED_RT_RTV2 = 'dog_breed_rt_rtv2',
  URGE_RT_9_RTV2 = 'urge_rt_9_rtv2',
  COMMANDS_61_RT_RTV2 = 'commands_61_rt_rtv2',
  COMMANDS_62_RT_RTV2 = 'commands_62_rt_rtv2',
  COMMANDS_63_RT_RTV2 = 'commands_63_rt_rtv2',
  URGE_RT_10_RTV2 = 'urge_rt_10_rtv2',
  URGE_LOADER_RT_RTV2 = 'urge_loader_rt_rtv2',
  DOG_STATISTICS_RT_RTV2 = 'dog_statistics_rt_rtv2',
  TRAINING_RT_RTV2 = 'training_rt_rtv2',
  PREPARE_FLOW_RT_RTV2 = 'prepare_flow_rt_rtv2',
  EMAIL_RT_RTV2 = 'email_rt_rtv2',
  NEWSLETTER_URGE_RTV2 = 'newsletter_urge_rtv2',
  URGE_RT_4_RTV2 = 'urge_rt_4_rtv2',
  LAST_CHANCE_OFFER_RT_V2_RTV2 = 'last_chance_offer_rt_v2_rtv2',
  SUBSCRIPTIONS_RT_RTV2 = 'subscriptions_rt_rtv2',
  CHAT_UPSELL_RTV2 = 'chat_upsell_rtv2',
  UPSELL_1_RTV2 = 'upsell_1_rtv2',
  UPSELL_PITPAT_RTV2 = 'upsell_pitpat_rtv2',
  DOWNLOAD_RTV2 = 'download_rtv2',

  // woofz_ndd
  SUBSCRIPTIONS_NDD = 'subscriptions_ndd',
  CANCEL_OFFER_NDD = 'cancel_offer_ndday',
  CHAT_UPSELL_NDD = 'chat_upsell_ndd',
  UPSELL_NDD = 'upsell_ndd',
  DOWNLOAD_NDD = 'download_ndd',

  // woofz_ndd_65
  SUBSCRIPTIONS_NDD_65 = 'subscriptions_ndd_65',
  CHAT_UPSELL_NDD_65 = 'chat_upsell_ndd_65',
  UPSELL_NDD_65 = 'upsell_ndd_65',
  DOWNLOAD_NDD_65 = 'download_ndd_65',

  // woofz_ndd_70
  SUBSCRIPTIONS_NDD_70 = 'subscriptions_ndd_70',
  CHAT_UPSELL_NDD_70 = 'chat_upsell_ndd_70',
  UPSELL_NDD_70 = 'upsell_ndd_70',
  DOWNLOAD_NDD_70 = 'download_ndd_70',

  // woofz_ndd_75
  SUBSCRIPTIONS_NDD_75 = 'subscriptions_ndd_75',
  CHAT_UPSELL_NDD_75 = 'chat_upsell_ndd_75',
  UPSELL_NDD_75 = 'upsell_ndd_75',
  DOWNLOAD_NDD_75 = 'download_ndd_75',

  // woofz_ndd_80
  SUBSCRIPTIONS_NDD_80 = 'subscriptions_ndd_80',
  CHAT_UPSELL_NDD_80 = 'chat_upsell_ndd_80',
  UPSELL_NDD_80 = 'upsell_ndd_80',
  DOWNLOAD_NDD_80 = 'download_ndd_80',

  // woofz_pup_bl
  DOG_AGE_PUP_BL = 'dog_age_pup_bl',
  DOG_OWNER_PUP_BL = 'dog_owner_pup_bl',
  TRAINING_COMMANDS_PUP_BL = 'training_commands_pup_bl',
  URGE_PAGE_PUP_BL = 'urge_page_pup_bl',
  DOG_BREED_PUP_BL = 'dog_breed_pup_bl',
  FACING_CHALLENGES_PUP_BL = 'facing_challenges_pup_bl',
  FACING_CHALLENGES_2_PUP_BL = 'facing_challenges_2_pup_bl',
  BEHAVIOR_FREQUENCY_PUP_BL = 'behavior_frequency_pup_bl',
  URGE_PROGRAM_PUP_BL = 'urge_program_pup_bl',
  BEHAVIOR_FEELINGS_PUP_BL = 'behavior_feelings_pup_bl',
  FIX_BEHAVIOR_PUP_BL = 'fix_behavior_pup_bl',
  URGE_PAGE_4_PUP_BL = 'urge_page_4_pup_bl',
  COMMANDS_PUP_BL = 'commands_pup_bl',
  PARENT_GOAL_PUP_BL = 'parent_goal_pup_bl',
  TRAINING_PLACE_PUP_BL = 'training_place_pup_bl',
  TRAINING_FREQUENCY_PUP_BL = 'training_frequency_pup_bl',
  URGE_PAGE_5_PUP_BL = 'urge_page_5_pup_bl',
  PREPARE_FLOW_PUP_BL = 'prepare_flow_pup_bl',
  EMAIL_PUP_BL = 'email_pup_bl',
  NEWSLETTER_URGE_PUP_BL = 'newsletter_urge_pup_bl',
  LAST_CHANCE_OFFER_PUP_BL = 'last_chance_offer_pup_bl',
  SUBSCRIPTIONS_PUP_BL = 'subscriptions_pup_bl',
  CHAT_UPSELL_PUP_BL = 'chat_upsell_pup_bl',
  UPSELL_PUP_BL = 'upsell_pup_bl',
  UPSELL_FEEDING_GUIDE_PUP_BL = 'upsell_feeding_guide_pup_bl',
  UPSELL_EMOTIONAL_SUPPORT_PUP_BL = 'upsell_emotional_support_pup_bl',
  DOWNLOAD_PUP_BL = 'download_pup_bl',

  // woofz_invx
  SUBSCRIPTIONS_INVOXIA_INVX = 'subscriptions_invoxia_invx',
  INVOXIA_CONGRATULATIONS_INVX = 'invoxia_congratulations_invx',
  INVOXIA_REVIEW_INVX = 'invoxia_review_invx',
  INVOXIA_DETAILS_INVX = 'invoxia_details_invx',

  // woofz_pup_wt
  DOG_AGE_PUP_WT = 'dog_age_pup_wt',
  DOG_OWNER_PUP_WT = 'dog_owner_pup_wt',
  TRAINING_COMMANDS_PUP_WT = 'training_commands_pup_wt',
  URGE_PAGE_PUP_WT = 'urge_page_pup_wt',
  DOG_BREED_PUP_WT = 'dog_breed_pup_wt',
  FACING_CHALLENGES_PUP_WT = 'facing_challenges_pup_wt',
  FACING_CHALLENGES_2_PUP_WT = 'facing_challenges_2_pup_wt',
  BEHAVIOR_FREQUENCY_PUP_WT = 'behavior_frequency_pup_wt',
  URGE_PROGRAM_PUP_WT = 'urge_program_pup_wt',
  BEHAVIOR_FEELINGS_PUP_WT = 'behavior_feelings_pup_wt',
  FIX_BEHAVIOR_PUP_WT = 'fix_behavior_pup_wt',
  URGE_PAGE_4_PUP_WT = 'urge_page_4_pup_wt',
  COMMANDS_PUP_WT = 'commands_pup_wt',
  PARENT_GOAL_PUP_WT = 'parent_goal_pup_wt',
  TRAINING_PLACE_PUP_WT = 'training_place_pup_wt',
  TRAINING_FREQUENCY_PUP_WT = 'training_frequency_pup_wt',
  URGE_PAGE_5_PUP_WT = 'urge_page_5_pup_wt',
  PREPARE_FLOW_PUP_WT = 'prepare_flow_pup_wt',
  EMAIL_PUP_WT = 'email_pup_wt',
  NEWSLETTER_URGE_PUP_WT = 'newsletter_urge_pup_wt',
  LAST_CHANCE_OFFER_PUP_WT = 'last_chance_offer_pup_wt',
  SUBSCRIPTIONS_PUP_WT = 'subscriptions_pup_wt',
  CHAT_UPSELL_PUP_WT = 'chat_upsell_pup_wt',
  UPSELL_PUP_WT = 'upsell_pup_wt',
  UPSELL_FEEDING_GUIDE_PUP_WT = 'upsell_feeding_guide_pup_wt',
  UPSELL_EMOTIONAL_SUPPORT_PUP_WT = 'upsell_emotional_support_pup_wt',
  DOWNLOAD_PUP_WT = 'download_pup_wt',

  // woofz_pup_drsl
  DOG_AGE_PUP_DRSL = 'dog_age_pup_drsl',
  DOG_OWNER_PUP_DRSL = 'dog_owner_pup_drsl',
  TRAINING_COMMANDS_PUP_DRSL = 'training_commands_pup_drsl',
  URGE_PAGE_PUP_DRSL = 'urge_page_pup_drsl',
  DOG_BREED_PUP_DRSL = 'dog_breed_pup_drsl',
  FACING_CHALLENGES_PUP_DRSL = 'facing_challenges_pup_drsl',
  FACING_CHALLENGES_2_PUP_DRSL = 'facing_challenges_2_pup_drsl',
  BEHAVIOR_FREQUENCY_PUP_DRSL = 'behavior_frequency_pup_drsl',
  URGE_PROGRAM_PUP_DRSL = 'urge_program_pup_drsl',
  BEHAVIOR_FEELINGS_PUP_DRSL = 'behavior_feelings_pup_drsl',
  FIX_BEHAVIOR_PUP_DRSL = 'fix_behavior_pup_drsl',
  URGE_PAGE_4_PUP_DRSL = 'urge_page_4_pup_drsl',
  COMMANDS_PUP_DRSL = 'commands_pup_drsl',
  PARENT_GOAL_PUP_DRSL = 'parent_goal_pup_drsl',
  TRAINING_PLACE_PUP_DRSL = 'training_place_pup_drsl',
  TRAINING_FREQUENCY_PUP_DRSL = 'training_frequency_pup_drsl',
  URGE_PAGE_5_PUP_DRSL = 'urge_page_5_pup_drsl',
  PREPARE_FLOW_PUP_DRSL = 'prepare_flow_pup_drsl',
  EMAIL_PUP_DRSL = 'email_pup_drsl',
  NEWSLETTER_URGE_PUP_DRSL = 'newsletter_urge_pup_drsl',
  LAST_CHANCE_OFFER_PUP_DRSL = 'last_chance_offer_pup_drsl',
  SUBSCRIPTIONS_PUP_DRSL = 'subscriptions_pup_drsl',
  CHAT_UPSELL_PUP_DRSL = 'chat_upsell_pup_drsl',
  UPSELL_PUP_DRSL = 'upsell_pup_drsl',
  UPSELL_FEEDING_GUIDE_PUP_DRSL = 'upsell_feeding_guide_pup_drsl',
  UPSELL_EMOTIONAL_SUPPORT_PUP_DRSL = 'upsell_emotional_support_pup_drsl',
  DOWNLOAD_PUP_DRSL = 'download_pup_drsl',

  // woofz_k9
  DOG_AGE_K9 = 'dog_age_k9',
  DOG_SEX_K9 = 'dog_sex_k9',
  DOG_BREED_K9 = 'dog_breed_k9',
  DOG_BREED_ID_K9 = 'dog_breed_id_k9',
  URGE_K9 = 'urge_k9',
  CHALLENGES_K9 = 'challenges_k9',
  URGE_1_K9 = 'urge_1_k9',
  LEASH_PULLING_K9 = 'leash_pulling_k9',
  URGE_LEASH_K9 = 'urge_leash_k9',
  DURING_WALK_K9 = 'during_walk_k9',
  URGE_NOT_ALONE_K9 = 'urge_not_alone_k9',
  AGRESSIVE_BEHAVIOR_K9 = 'agressive_behavior_k9',
  TRIGGERS_K9 = 'triggers_k9',
  URGE_2_K9 = 'urge_2_k9',
  BEHAVIOR_ISSUES_K9 = 'behavior_issues_k9',
  DOG_ACT_K9 = 'dog_act_k9',
  DOG_OFF_AT_HOME_K9 = 'dog_off_at_home_k9',
  REWARDS_K9 = 'rewards_k9',
  IGNORE_COMMANDS_K9 = 'ignore_commands_k9',
  COMMANDS_61_K9 = 'commands_61_k9',
  COMMANDS_62_K9 = 'commands_62_k9',
  COMMANDS_63_K9 = 'commands_63_k9',
  URGE_3_K9 = 'urge_3_k9',
  PREPARE_SCREEN_K9 = 'prepare_screen_k9',
  DOG_PROFILE_K9 = 'dog_profile_k9',
  URGE_REVIEWED_K9 = 'urge_reviewed_k9',
  SOCIAL_SCREEN_K9 = 'social_screen_k9',
  PREPARE_FLOW_K9 = 'prepare_flow_k9',
  EMAIL_K9 = 'email_k9',
  NEWSLETTER_URGE_K9 = 'newsletter_urge_k9',
  DISCIPLINE_SCREEN_K9 = 'discipline_screen_k9',
  SCRATCH_SCREEN_K9 = 'scratch_screen_k9',
  SUBSCRIPTIONS_K9 = 'subscriptions_k9',
  CHAT_UPSELL_K9 = 'chat_upsell_k9',
  UPSELL_K9 = 'upsell_k9',
  UPSELL_FEEDING_GUIDE_K9 = 'upsell_feeding_guide_k9',
  UPSELL_EMOTIONAL_SUPPORT_K9 = 'upsell_emotional_support_k9',
  DOWNLOAD_K9 = 'download_k9',
  ACCOUNT_K9 = 'account_k9',
  WELCOME_TO_WOOFZ_K9 = 'welcome_to_woofz_k9',

  // woofz_vday_65
  SUBSCRIPTIONS_VDAY_65 = 'subscriptions_vday_65',
  CHAT_UPSELL_VDAY_65 = 'chat_upsell_vday_65',
  UPSELL_VDAY_65 = 'upsell_vday_65',
  DOWNLOAD_VDAY_65 = 'download_vday_65',

  // woofz_vday_70
  SUBSCRIPTIONS_VDAY_70 = 'subscriptions_vday_70',
  CHAT_UPSELL_VDAY_70 = 'chat_upsell_vday_70',
  UPSELL_VDAY_70 = 'upsell_vday_70',
  DOWNLOAD_VDAY_70 = 'download_vday_70',

  // woofz_vday_75
  SUBSCRIPTIONS_VDAY_75 = 'subscriptions_vday_75',
  CHAT_UPSELL_VDAY_75 = 'chat_upsell_vday_75',
  UPSELL_VDAY_75 = 'upsell_vday_75',
  DOWNLOAD_VDAY_75 = 'download_vday_75',

  // woofz_vday_80
  SUBSCRIPTIONS_VDAY_80 = 'subscriptions_vday_80',
  CHAT_UPSELL_VDAY_80 = 'chat_upsell_vday_80',
  UPSELL_VDAY_80 = 'upsell_vday_80',
  DOWNLOAD_VDAY_80 = 'download_vday_80',

  // woofz_hlwn_65
  SUBSCRIPTIONS_PAGE_HLWN_65 = 'subscriptions_page_hlwn_65',
  CHAT_UPSELL_HLWN_65 = 'chat_upsell_hlwn_65',
  UPSELL_HLWN_65 = 'upsell_hlwn_65',
  DOWNLOAD_HLWN_65 = 'download_hlwn_65',

  // woofz_hlwn_70
  SUBSCRIPTIONS_PAGE_HLWN_70 = 'subscriptions_page_hlwn_70',
  CHAT_UPSELL_HLWN_70 = 'chat_upsell_hlwn_70',
  UPSELL_HLWN_70 = 'upsell_hlwn_70',
  DOWNLOAD_HLWN_70 = 'download_hlwn_70',

  // woofz_hlwn_75
  SUBSCRIPTIONS_PAGE_HLWN_75 = 'subscriptions_page_hlwn_75',
  CHAT_UPSELL_HLWN_75 = 'chat_upsell_hlwn_75',
  UPSELL_HLWN_75 = 'upsell_hlwn_75',
  DOWNLOAD_HLWN_75 = 'download_hlwn_75',

  // woofz_hlwn_80
  SUBSCRIPTIONS_PAGE_HLWN_80 = 'subscriptions_page_hlwn_80',
  CHAT_UPSELL_HLWN_80 = 'chat_upsell_hlwn_80',
  UPSELL_HLWN_80 = 'upsell_hlwn_80',
  DOWNLOAD_HLWN_80 = 'download_hlwn_80',

  // woofz_sub_cnld_70
  SUBSCRIPTIONS_CNLD_70 = 'subscriptions_cnld_70',
  CHAT_UPSELL_CNLD_70 = 'chat_upsell_cnld_70',
  UPSELL_CNLD_70 = 'upsell_cnld_70',
  DOWNLOAD_CNLD_70 = 'download_cnld_70',

  // woofz_k9_bl
  DOG_AGE_K9_BL = 'dog_age_k9_bl',
  DOG_SEX_K9_BL = 'dog_sex_k9_bl',
  DOG_BREED_K9_BL = 'dog_breed_k9_bl',
  DOG_BREED_ID_K9_BL = 'dog_breed_id_k9_bl',
  URGE_K9_BL = 'urge_k9_bl',
  CHALLENGES_K9_BL = 'challenges_k9_bl',
  URGE_1_K9_BL = 'urge_1_k9_bl',
  LEASH_PULLING_K9_BL = 'leash_pulling_k9_bl',
  URGE_LEASH_K9_BL = 'urge_leash_k9_bl',
  DURING_WALK_K9_BL = 'during_walk_k9_bl',
  URGE_NOT_ALONE_K9_BL = 'urge_not_alone_k9_bl',
  AGRESSIVE_BEHAVIOR_K9_BL = 'agressive_behavior_k9_bl',
  TRIGGERS_K9_BL = 'triggers_k9_bl',
  URGE_2_K9_BL = 'urge_2_k9_bl',
  BEHAVIOR_ISSUES_K9_BL = 'behavior_issues_k9_bl',
  DOG_ACT_K9_BL = 'dog_act_k9_bl',
  DOG_OFF_AT_HOME_K9_BL = 'dog_off_at_home_k9_bl',
  REWARDS_K9_BL = 'rewards_k9_bl',
  IGNORE_COMMANDS_K9_BL = 'ignore_commands_k9_bl',
  COMMANDS_61_K9_BL = 'commands_61_k9_bl',
  COMMANDS_62_K9_BL = 'commands_62_k9_bl',
  COMMANDS_63_K9_BL = 'commands_63_k9_bl',
  URGE_3_K9_BL = 'urge_3_k9_bl',
  PREPARE_SCREEN_K9_BL = 'prepare_screen_k9_bl',
  DOG_PROFILE_K9_BL = 'dog_profile_k9_bl',
  URGE_REVIEWED_K9_BL = 'urge_reviewed_k9_bl',
  SOCIAL_SCREEN_K9_BL = 'social_screen_k9_bl',
  PREPARE_FLOW_K9_BL = 'prepare_flow_k9_bl',
  EMAIL_K9_BL = 'email_k9_bl',
  NEWSLETTER_URGE_K9_BL = 'newsletter_urge_k9_bl',
  DISCIPLINE_SCREEN_K9_BL = 'discipline_screen_k9_bl',
  SCRATCH_SCREEN_K9_BL = 'scratch_screen_k9_bl',
  SUBSCRIPTIONS_K9_BL = 'subscriptions_k9_bl',
  CHAT_UPSELL_K9_BL = 'chat_upsell_k9_bl',
  UPSELL_K9_BL = 'upsell_k9_bl',
  UPSELL_FEEDING_GUIDE_K9_BL = 'upsell_feeding_guide_k9_bl',
  UPSELL_EMOTIONAL_SUPPORT_K9_BL = 'upsell_emotional_support_k9_bl',
  DOWNLOAD_K9_BL = 'download_k9_bl',
  ACCOUNT_K9_BL = 'account_k9_bl',

  // woofz_k9_bl_bg
  DOG_AGE_K9_BL_BG = 'dog_age_k9_bl_bg',
  DOG_SEX_K9_BL_BG = 'dog_sex_k9_bl_bg',
  DOG_BREED_K9_BL_BG = 'dog_breed_k9_bl_bg',
  DOG_BREED_ID_K9_BL_BG = 'dog_breed_id_k9_bl_bg',
  URGE_K9_BL_BG = 'urge_k9_bl_bg',
  CHALLENGES_K9_BL_BG = 'challenges_k9_bl_bg',
  URGE_1_K9_BL_BG = 'urge_1_k9_bl_bg',
  LEASH_PULLING_K9_BL_BG = 'leash_pulling_k9_bl_bg',
  URGE_LEASH_K9_BL_BG = 'urge_leash_k9_bl_bg',
  DURING_WALK_K9_BL_BG = 'during_walk_k9_bl_bg',
  URGE_NOT_ALONE_K9_BL_BG = 'urge_not_alone_k9_bl_bg',
  AGRESSIVE_BEHAVIOR_K9_BL_BG = 'agressive_behavior_k9_bl_bg',
  TRIGGERS_K9_BL_BG = 'triggers_k9_bl_bg',
  URGE_2_K9_BL_BG = 'urge_2_k9_bl_bg',
  BEHAVIOR_ISSUES_K9_BL_BG = 'behavior_issues_k9_bl_bg',
  DOG_ACT_K9_BL_BG = 'dog_act_k9_bl_bg',
  DOG_OFF_AT_HOME_K9_BL_BG = 'dog_off_at_home_k9_bl_bg',
  REWARDS_K9_BL_BG = 'rewards_k9_bl_bg',
  IGNORE_COMMANDS_K9_BL_BG = 'ignore_commands_k9_bl_bg',
  COMMANDS_61_K9_BL_BG = 'commands_61_k9_bl_bg',
  COMMANDS_62_K9_BL_BG = 'commands_62_k9_bl_bg',
  COMMANDS_63_K9_BL_BG = 'commands_63_k9_bl_bg',
  URGE_3_K9_BL_BG = 'urge_3_k9_bl_bg',
  PREPARE_SCREEN_K9_BL_BG = 'prepare_screen_k9_bl_bg',
  DOG_PROFILE_K9_BL_BG = 'dog_profile_k9_bl_bg',
  URGE_REVIEWED_K9_BL_BG = 'urge_reviewed_k9_bl_bg',
  PREPARE_FLOW_K9_BL_BG = 'prepare_flow_k9_bl_bg',
  EMAIL_K9_BL_BG = 'email_k9_bl_bg',
  NEWSLETTER_URGE_K9_BL_BG = 'newsletter_urge_k9_bl_bg',
  SCRATCH_SCREEN_K9_BL_BG = 'scratch_screen_k9_bl_bg',
  SUBSCRIPTIONS_K9_BL_BG = 'subscriptions_k9_bl_bg',
  CHAT_UPSELL_K9_BL_BG = 'chat_upsell_k9_bl_bg',
  UPSELL_K9_BL_BG = 'upsell_k9_bl_bg',
  UPSELL_FEEDING_GUIDE_K9_BL_BG = 'upsell_feeding_guide_k9_bl_bg',
  UPSELL_EMOTIONAL_SUPPORT_K9_BL_BG = 'upsell_emotional_support_k9_bl_bg',
  DOWNLOAD_K9_BL_BG = 'download_k9_bl_bg',
  ACCOUNT_K9_BL_BG = 'account_k9_bl_bg',

  // woofz_k9_drsl
  DOG_AGE_K9_DRSL = 'dog_age_k9_drsl',
  DOG_SEX_K9_DRSL = 'dog_sex_k9_drsl',
  DOG_BREED_K9_DRSL = 'dog_breed_k9_drsl',
  DOG_BREED_ID_K9_DRSL = 'dog_breed_id_k9_drsl',
  URGE_K9_DRSL = 'urge_k9_drsl',
  CHALLENGES_K9_DRSL = 'challenges_k9_drsl',
  URGE_1_K9_DRSL = 'urge_1_k9_drsl',
  LEASH_PULLING_K9_DRSL = 'leash_pulling_k9_drsl',
  URGE_LEASH_K9_DRSL = 'urge_leash_k9_drsl',
  DURING_WALK_K9_DRSL = 'during_walk_k9_drsl',
  URGE_NOT_ALONE_K9_DRSL = 'urge_not_alone_k9_drsl',
  AGRESSIVE_BEHAVIOR_K9_DRSL = 'agressive_behavior_k9_drsl',
  TRIGGERS_K9_DRSL = 'triggers_k9_drsl',
  URGE_2_K9_DRSL = 'urge_2_k9_drsl',
  BEHAVIOR_ISSUES_K9_DRSL = 'behavior_issues_k9_drsl',
  DOG_ACT_K9_DRSL = 'dog_act_k9_drsl',
  DOG_OFF_AT_HOME_K9_DRSL = 'dog_off_at_home_k9_drsl',
  REWARDS_K9_DRSL = 'rewards_k9_drsl',
  IGNORE_COMMANDS_K9_DRSL = 'ignore_commands_k9_drsl',
  COMMANDS_61_K9_DRSL = 'commands_61_k9_drsl',
  COMMANDS_62_K9_DRSL = 'commands_62_k9_drsl',
  COMMANDS_63_K9_DRSL = 'commands_63_k9_drsl',
  URGE_3_K9_DRSL = 'urge_3_k9_drsl',
  PREPARE_SCREEN_K9_DRSL = 'prepare_screen_k9_drsl',
  DOG_PROFILE_K9_DRSL = 'dog_profile_k9_drsl',
  URGE_REVIEWED_K9_DRSL = 'urge_reviewed_k9_drsl',
  PREPARE_FLOW_K9_DRSL = 'prepare_flow_k9_drsl',
  EMAIL_K9_DRSL = 'email_k9_drsl',
  NEWSLETTER_URGE_K9_DRSL = 'newsletter_urge_k9_drsl',
  SUBSCRIPTIONS_K9_DRSL = 'subscriptions_k9_drsl',
  CHAT_UPSELL_K9_DRSL = 'chat_upsell_k9_drsl',
  UPSELL_K9_DRSL = 'upsell_k9_drsl',
  UPSELL_FEEDING_GUIDE_K9_DRSL = 'upsell_feeding_guide_k9_drsl',
  UPSELL_EMOTIONAL_SUPPORT_K9_DRSL = 'upsell_emotional_support_k9_drsl',
  DOWNLOAD_K9_DRSL = 'download_k9_drsl',
  ACCOUNT_K9_DRSL = 'account_k9_drsl',
  WELCOME_TO_WOOFZ_K9_DRSL = 'welcome_to_woofz_k9_drsl',

  // woofz_woofy1
  HELLO_WOOFY = 'hello_woofy',
  COACH_WOOFY = 'coach_woofy',
  CHAT_WOOFY = 'chat',
  DOG_AGE_WOOFY = 'dog_age_woofy',
  BEHAVIOR_WOOFY = 'behavior_woofy',
  URGE_WOOFY = 'urge_woofy',
  PREPARE_FLOW_WOOFY = 'prepare_flow_woofy',
  EMAIL_WOOFY = 'email_woofy',
  SUBSCRIPTIONS_WOOFY = 'subscriptions_woofy',
  DOWNLOAD_WOOFY = 'download_woofy',
  ACCOUNT_WOOFY = 'account_woofy',

  // woofz_coaching
  DOG_SELECTOR = 'dog_selector',
  PROBLEM_DESCRIPTION = 'problem_description',
  DOG_BREED_COACHING = 'dog_breed_coaching',
  DOG_AGE_COACHING = 'dog_age_coaching',
  DOG_PROFILE_COACHING = 'dog_profile_coaching',
  SUBSCRIPTIONS_COACHING = 'subscriptions_coaching',
  CANCEL_OFFER_COACHING = 'cancel_offer_coaching',
  CALENDLY_COACHING = 'calendly_coaching',
  ALL_SET_COACHING = 'all_set_coaching',

  // woofz_smd
  DOG_AGE_SMD = 'dog_age_smd',
  DOG_SEX_SMD = 'dog_sex_smd',
  DOG_BREED_SMD = 'dog_breed_smd',
  URGE_SMD = 'urge_smd',
  GOALS_SMD = 'goals_smd',
  URGE_1_SMD = 'urge_1_smd',
  AGRESSIVE_BEHAVIOR_SMD = 'agressive_behavior_smd',
  TRIGGERS_SMD = 'triggers_smd',
  URGE_2_SMD = 'urge_2_smd',
  BEHAVIOR_ISSUES_SMD = 'behavior_issues_smd',
  DOG_LISTEN_SMD = 'dog_listen_smd',
  COMMANDS_SMD = 'commands_smd',
  EAT_OFF_THE_GROUND_SMD = 'eat_off_the_ground_smd',
  DOG_ACT_SMD = 'dog_act_smd',
  DOG_OFF_AT_HOME_SMD = 'dog_off_at_home_smd',
  PREPARE_SCREEN_SMD = 'prepare_screen_smd',
  DOG_PROFILE_SMD = 'dog_profile_smd',
  HEAR_ABOUT_WOOFZ_SMD = 'hear_about_woofz_smd',
  MANNERS_TO_BUILD_SMD = 'manners_to_build_smd',
  FEEL_BETTER_SMD = 'feel_better_smd',
  PREPARE_FLOW_SMD = 'prepare_flow_smd',
  EMAIL_SMD = 'email_smd',
  NEWSLETTER_URGE_SMD = 'newsletter_urge_smd',
  SCRATCH_SCREEN_SMD = 'scratch_screen_smd',
  SUBSCRIPTIONS_SMD = 'subscriptions_smd',
  CHAT_UPSELL_SMD = 'chat_upsell_smd',
  UPSELL_SMD = 'upsell_smd',
  UPSELL_FEEDING_GUIDE_SMD = 'upsell_feeding_guide_smd',
  UPSELL_EMOTIONAL_SUPPORT_SMD = 'upsell_emotional_support_smd',
  DOWNLOAD_SMD = 'download_smd',
  ACCOUNT_SMD = 'account_smd',

  // woofz_smd_bl
  DOG_AGE_SMD_BL = 'dog_age_smd_bl',
  DOG_SEX_SMD_BL = 'dog_sex_smd_bl',
  DOG_BREED_SMD_BL = 'dog_breed_smd_bl',
  URGE_SMD_BL = 'urge_smd_bl',
  GOALS_SMD_BL = 'goals_smd_bl',
  URGE_1_SMD_BL = 'urge_1_smd_bl',
  AGRESSIVE_BEHAVIOR_SMD_BL = 'agressive_behavior_smd_bl',
  TRIGGERS_SMD_BL = 'triggers_smd_bl',
  URGE_2_SMD_BL = 'urge_2_smd_bl',
  BEHAVIOR_ISSUES_SMD_BL = 'behavior_issues_smd_bl',
  DOG_LISTEN_SMD_BL = 'dog_listen_smd_bl',
  COMMANDS_SMD_BL = 'commands_smd_bl',
  EAT_OFF_THE_GROUND_SMD_BL = 'eat_off_the_ground_smd_bl',
  DOG_ACT_SMD_BL = 'dog_act_smd_bl',
  DOG_OFF_AT_HOME_SMD_BL = 'dog_off_at_home_smd_bl',
  PREPARE_SCREEN_SMD_BL = 'prepare_screen_smd_bl',
  DOG_PROFILE_SMD_BL = 'dog_profile_smd_bl',
  HEAR_ABOUT_WOOFZ_SMD_BL = 'hear_about_woofz_smd_bl',
  MANNERS_TO_BUILD_SMD_BL = 'manners_to_build_smd_bl',
  FEEL_BETTER_SMD_BL = 'feel_better_smd_bl',
  PREPARE_FLOW_SMD_BL = 'prepare_flow_smd_bl',
  EMAIL_SMD_BL = 'email_smd_bl',
  NEWSLETTER_URGE_SMD_BL = 'newsletter_urge_smd_bl',
  SCRATCH_SCREEN_SMD_BL = 'scratch_screen_smd_bl',
  SUBSCRIPTIONS_SMD_BL = 'subscriptions_smd_bl',
  CHAT_UPSELL_SMD_BL = 'chat_upsell_smd_bl',
  UPSELL_SMD_BL = 'upsell_smd_bl',
  UPSELL_FEEDING_GUIDE_SMD_BL = 'upsell_feeding_guide_smd_bl',
  UPSELL_EMOTIONAL_SUPPORT_SMD_BL = 'upsell_emotional_support_smd_bl',
  DOWNLOAD_SMD_BL = 'download_smd_bl',
  ACCOUNT_SMD_BL = 'account_smd_bl',

  // woofz_paw_nup
  WELCOME_PAW_NUP = 'welcome_paw_nup',
  HOW_IT_WORKS_PAW_NUP = 'how_it_works_paw_nup',
  INTRODUCTION_PAW_NUP = 'introduction_paw_nup',
  MORNING_WALK_PAW_NUP = 'morning_walk_paw_nup',
  EVENING_WALK_PAW_NUP = 'evening_walk_paw_nup',
  FEEDING_PAW_NUP = 'feeding_paw_nup',
  VET_CARE_PAW_NUP = 'vet_care_paw_nup',
  TRAINING_PAW_NUP = 'training_paw_nup',
  DISCIPLINE_PAW_NUP = 'discipline_paw_nup',
  CLEANUP_PAW_NUP = 'cleanup_paw_nup',
  TREATS_PAW_NUP = 'treats_paw_nup',
  KISSES_PAW_NUP = 'kisses_paw_nup',
  GROOMING_PAW_NUP = 'grooming_paw_nup',
  NIGHT_DUTY_PAW_NUP = 'night_duty_paw_nup',
  RULES_PAW_NUP = 'rules_paw_nup',
  ALLOWED_ON_BED_PAW_NUP = 'allowed_on_bed_paw_nup',
  TABLE_SCRAPS_PAW_NUP = 'table_scraps_paw_nup',
  WHINES_PAW_NUP = 'whines_paw_nup',
  COMMANDS_PAW_NUP = 'commands_paw_nup',
  LISTEN_TO_PAW_NUP = 'listen_to_paw_nup',
  CREATING_AGREEMENT_PAW_NUP = 'creating_agreement_paw_nup',
  CONFLICT_PROOF_PAW_NUP = 'conflict_proof_paw_nup',
  EMAIL_PAW_NUP = 'email_paw_nup',
  AGREEMENT_PAW_NUP = 'agreement_paw_nup',
  DOWNLOAD_PAW_NUP = 'download_paw_nup',

  // woofz_22v9
  DOG_AGE_V9 = 'dog_age_v9',
  URGE_V9 = 'urge_v9',
  URGE_2_V9 = 'urge_2_v9',
  DOG_STATISTICS_V9 = 'dog_statistics_v9',
  EMAIL_V9 = 'email_v9',
  CONGRATS_V9 = 'congrats_v9',
  SEX_V9 = 'sex_v9',
  DOG_BREED_V9 = 'dog_breed_v9',
  DOG_BREED_ID_V9 = 'dog_breed_id_v9',
  COMMANDS_61_V9 = 'commands_61_v9',
  COMMANDS_62_V9 = 'commands_62_v9',
  COMMANDS_63_V9 = 'commands_63_v9',
  COMMANDS_64_V9 = 'commands_64_v9',
  POTTY_V9 = 'potty_v9',
  BEHAVIOR_V9 = 'behavior_v9',
  TRAINING_V9 = 'training_v9',
  PREPARE_FLOW_V9 = 'prepare_flow_v9',
  SUBSCRIPTIONS_V9 = 'subscriptions_v9',
  CANCEL_OFFER_V9 = 'cancel_offer_v9',
  CHAT_UPSELL_V9 = 'chat_upsell_v9',
  UPSELL_V9 = 'upsell_v9',
  UPSELL_PITPAT_V9 = 'upsell_pitpat_v9',
  DOWNLOAD_V9 = 'download_v9',

  ACCOUNT_NOVE8 = 'account_nove8',
}
